import React from 'react';
import {
  Button,
  ShareButton,
  OpenToggle
} from "..";
import { slugify } from '../../../../../utils/string_util';
import Social from '../../../../components/social/social';

const ListItem = ({
  icon,
  rank = '01',
  title,
  blurb,
  link,
  description,
  active,
  bgColor = "#f7f7f7",
  activeBgColor = "#ffffff",
  canCollapse = true,
  ranked = true,
  withArrow = false,
  category,
  subtitle,
  onClick = () => {}
}) => {
  const isTop10 = parseInt(rank) <= 10;

  const handleShareClick = (e) => {
    const shareContainer = e.target.closest('.shareButton__container').nextElementSibling;
    const shareButtons = shareContainer.firstElementChild;
    if(shareButtons.style.left !== '0px') {
      shareContainer.firstElementChild.style.left = '0px';
    }else{
      shareContainer.firstElementChild.style.left = '-300px';
    }
  }

  return (
    <div
      className={`listItem__container listItem__container${active ? '--active' : '--default'}`}
      style={{
        backgroundColor: active ? activeBgColor : bgColor
      }}
    >
      <div className="listItem__container__inner">
        <div className="listItem__container__upper">
          {ranked && (
            <div className={`listItem__rank${isTop10 ? '--top10' : ''}`}>{rank}</div>
          )}
          {icon && (
            <div className={`listItem__icon`}>
              <img src={icon} alt={`icon for ${title || 'list item'}`} />
            </div>
          )}
          <div className={`listItem__meta listItem__meta${isTop10 ? '--top10' : '--standard'}`}>
            {category && (<div className={`listItem__category`}>{category}</div>)}
            <div className={`listItem__title ${withArrow ? 'withArrow' : ''}`}>{title}</div>
            {subtitle && (<div className={`listItem__subtitle`}>{subtitle}</div>)}
            <div className="listItem__blurb" dangerouslySetInnerHTML={{__html: blurb}} />
          </div>
          {canCollapse && (
            <div className="listItem__expand">
              <OpenToggle
                active={active}
                color="#000000"
                activeColor="#000000"
              />
            </div>
          )}
        </div>
        <div className={`listItem__container__lower listItem__container__lower${active ? '--open' : ''}`}>          
            {ranked && (
              <div className={`listItem--hidden listItem--mobile-none listItem__rank${isTop10 ? '--top10' : ''}`}>{rank}</div>
            )}
            <div className={`listItem__meta listItem__meta${isTop10 ? '--top10' : ''}`}>
              <div className="listItem__description" dangerouslySetInnerHTML={{__html: description}} />
              <div className="listItem__actions">
                {link && (
                  <a className="listItem__more" target="_blank" href={link}>
                    <Button rounded label="More" bgColor="#EF5B24" labelHoverColor="#ffffff" />
                  </a>
                )}
                <ShareButton label="Share" onClick={handleShareClick} />
                <div className="shareButtons__container">
                  <Social
                    empty={false}
                    enableSticky={false}
                    modifier="mic-year-sector"
                    uri={encodeURIComponent(`https://www.fastcompany.com/most-innovative-companies/list#${slugify(title)}`)}
                    text={encodeURIComponent(
                      `@FastCompany's Most Innovative Companies 2022 #FCMostInnovative`
                    )}
                  />
                </div>
              </div>
            </div>
            {canCollapse && (
              <div className="listItem--hidden listItem--mobile-none listItem__expand">
                <OpenToggle
                  active={active}
                  color="#000000"
                  activeColor="#c7c7c7"
                />
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

ListItem.displayName = 'ListItem';

export default ListItem;